export default function Header() {
    return (
        <nav className="header">
            <div className="top-row">
                <a className="logo-wrapper" href="https://www.skoda.pl/" target="_self"></a>
            </div>
            <div className="bottom-row">
                <a href="https://www.skoda.pl/" target="_self">Przejdź do&nbsp;strony głównej</a>
            </div>
        </nav>
    );
}
